export default {
  namespaced: true,
  state: {
    prodCountry: [],
    primAudience: []
  },
  getters: {
    prodCountry: state => state.prodCountry,
    primAudience: state => state.primAudience
  },
  mutations: {
    setProdCountry(state, newValue) {
      state.prodCountry = newValue;
    },
    setPrimAudience(state, newValue) {
      state.primAudience = newValue;
    }
  }
};
